import { Button, Col, Row, Spinner } from "react-bootstrap";
import styles from '../../../../../styles/expenditureworksheet.module.css';
import ButtonOverride from "../../../../../components/buttonoverride";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleArrowLeft, faPlus, faSave } from "@fortawesome/free-solid-svg-icons";
import { Controller, useForm } from 'react-hook-form';
import React, { useEffect, useState } from "react";
import FileUpload from "../../../../../components/fileupload";
import ReceiptsPanel from "../receipts/receiptspanel";
import useApi from "../../../../../hooks/use-api";
import { NumericFormat } from "react-number-format";
import * as yup from 'yup';
import { yupResolver } from "@hookform/resolvers/yup"
import FormInputValidationMessage from "../../../../../components/forminputvalidationmessage";
import useMessageStore from "../../../../../stores/message-store";
import { appendFormData } from "../../../../../utilities/formdata";

const ExpenditureProCardAddEdit = ({ApplicationID, procardId, returnFunction,refresh,states, expenditureTypes = [],lineItemCategories = [], readOnly = false}) => {
    const proCardFormValues = {
        itemamount: null,
        itempurpose: "",
        itemtrackingnumber: "",
        transactiondate: "",
        expendituretypeid: null,
        vendorname: "",
        vendoraddress: "",
        vendorcity: "",
        vendorstate: -1,
        vendorzip: "",
        vendorphone: "",
        vendornote: "",
        comments: "",
    }

    const schemaObject = yup.object({
        itemtrackingnumber: yup.string().required('*Item Tracking Number is required.'),
        itemamount: yup.number().typeError('*Item Amount is required').required('*Item Amount is required.'),
        transactiondate: yup.date().typeError('*Transaction Date is required.').required('*Transaction Date is required').max(new Date().toISOString().split('T')[0], '*Date cannot be in the future'),
        expendituretypeid: yup.string().required('*Expenditure Type is required.'),
        vendorname: yup.string().required('*Vendor Name is required.')
    });

    const { register,control, watch,handleSubmit,reset, formState: { isSubmitting,errors,isDirty } } = useForm({
        defaultValues: proCardFormValues,
        resolver: yupResolver(schemaObject)
    });

    const [prevFiles, setPrevFiles] = useState([]);
    const [newFiles, setNewFiles] = useState([]);
    const [receiptItems, setReceiptItems] = useState([]);

    //Used for tracking to enable or disable submit button if something has changed
    const [initialPrevFiles,setInitialPrevFiles] = useState([]);
    const [initialLineItems,setInitialLineItems] = useState([]);

    const [isLoading,setIsLoading] = useState(() => procardId ? true : false); //Initalize state based on procardId being supplied
    

    const addToast = useMessageStore(state => state.addToast);

    const submit = async(values) => {

        const sendObject = {
            ...values,
            transactiondate: values.transactiondate.toISOString().split('T')[0], //Convert to proper format before sending
            lineitems: receiptItems,
            existingfiles: prevFiles,
            applicationid: ApplicationID,
            procardid: procardId
        }

        const formData = new FormData();

        appendFormData(formData,sendObject);

        for (let index = 0; index < newFiles.length; index++) {
          const element = newFiles[index].file;

          formData.append(`newfiles`, element);
        }

        if(!procardId){
            const [data,status] = await postFileRequest('ExpenditureWorksheet_Procard_Add',formData);

            if(status === 201){
                addToast({
                    id: Math.random(),
                    body: 'Procard added successfully!',
                    autoHide: true,
                    errorFlag: false,
                    timestamp: Date.now() - 1000
                })
                
                refresh();
                returnFunction();
            }
            else{
                addToast({
                    id: Math.random(),
                    body: 'An error occured when adding the Procard.',
                    autoHide: true,
                    errorFlag: true,
                    timestamp: Date.now() - 1000
                })
            }
        }
        else{
            const [data,status] = await putFileRequest('ExpenditureWorksheet_Procard_Update',formData);

            if(status === 200){
                setNewFiles([]);

                const {existingfiles,lineitems,...dataValues} = data;

                setPrevFiles(existingfiles);
                setReceiptItems(lineitems);

                setInitialLineItems(lineitems);
                setInitialPrevFiles(existingfiles);

                reset(dataValues);

                addToast({
                    id: Math.random(),
                    body: 'Procard updated successfully!',
                    autoHide: true,
                    errorFlag: false,
                    timestamp: Date.now() - 1000
                })
            }
            else{
                addToast({
                    id: Math.random(),
                    body: 'An error occured when updating the Procard.',
                    autoHide: true,
                    errorFlag: true,
                    timestamp: Date.now() - 1000
                })
            }

            refresh();

        }
    };

    const {getRequest,postFileRequest,putFileRequest} = useApi();

    const get = async() => {
        const [data,status] = await getRequest('ExpenditureWorksheet_Procard_Get',{procardid : procardId,timestamp: new Date()});

        setIsLoading(false);
        if(status === 200){
            const {existingfiles,lineitems,...dataValues} = data;

            setPrevFiles(existingfiles);
            setReceiptItems(lineitems);

            setInitialLineItems(lineitems);
            setInitialPrevFiles(existingfiles);

            reset(dataValues);
        }
        else{
            //Handle error gracefully
        }

    }

    useEffect(() => {
        if(procardId){
            get();
        }
        else{
            setPrevFiles([]);
            setReceiptItems([]);
            setNewFiles([]);
        }

    }, [])

    const amount = watch('itemamount');

    const existingFilesChanged = prevFiles.length !== initialPrevFiles.length;
    const existingLineItemsChanged = JSON.stringify(receiptItems) !== JSON.stringify(initialLineItems);
    const mismatchLineItemsAndAmount = !(amount === null && receiptItems.length === 0) ? amount?.toFixed(2) !== receiptItems.reduce((sum,current) => sum + current.amount,0).toFixed(2) : false;

    if(isLoading){
        return(
            <div>loading...</div>
        )
    }

    return (
        <form onSubmit={handleSubmit(submit)} autoComplete="off">
            <div className="clientCard">
                <div className="clientCardInner">
                    <div className={styles.expenditureSubNavContainer}>
                        <ButtonOverride type="button" className={styles.expenditureSubNavBackButton} aria-label="Return" onClick={returnFunction}>
                            <FontAwesomeIcon icon={faCircleArrowLeft} size="2xl" />
                        </ButtonOverride>
                        <h5 className={styles.expenditureSubNavTitle}>
                            {procardId === null ? <>Add Procard Entry</> : readOnly ? <>View Procard Entry #{procardId}</> : <>Edit Procard Entry #{procardId}</>}
                        </h5>
                    </div>
                    <div className={`${styles.addEditForm} mt-4`}>
                        <Row>
                            <Col xs={12} md={6}>
                                <Row>
                                    <Col xs={12} md={6}>
                                        <label htmlFor="trackingNumber" className="fw-bold">Tracking #</label>
                                        <input id="trackingNumber" type="text" {...register("itemtrackingnumber")} style={{ width: '100%' }} />
                                        <FormInputValidationMessage error={errors?.itemtrackingnumber} />
                                    </Col>
                                    <Col xs={12} md={6}>
                                        <label htmlFor="amount" className="fw-bold">Amount</label>
                                        <Controller
                                              name="itemamount"
                                              control={control}
                                              render={({ field }) => (
                                                    <NumericFormat 
                                                        value={field.value} 
                                                        id="amount" 
                                                        placeholder="Amount" 
                                                        style={{ width: '100%', height: '32px' }} 
                                                        prefix={'$'} 
                                                        decimalScale={2} 
                                                        fixedDecimalScale={true} 
                                                        allowNegative={false}
                                                        onValueChange={(values) => {
                                                            if(values.floatValue === undefined || values.floatValue === null){
                                                                field.onChange(proCardFormValues.itemamount); //Reset to default
                                                            }
                                                            else{
                                                                field.onChange(values.floatValue);
                                                            }
                                                        }} 
                                                    />
                                              )}
                                        />
                                          <FormInputValidationMessage error={errors?.itemamount} />
                                        <div>
                                            <label htmlFor="transactiondate" className="fw-bold">Transaction Date</label>
                                            <input type="date" id="transactiondate" {...register('transactiondate')} style={{ width: '100%' }} max={new Date().toISOString().split('T')[0]} />
                                            <FormInputValidationMessage error={errors?.transactiondate} />
                                        </div>
                                    </Col>
                                    <Col xs={12}>
                                        <label htmlFor="itempurpose">Item Purpose</label>
                                        <textarea id="itempurpose" {...register('itempurpose')} style={{ width: '100%' }} rows={4} />
                                    </Col>
                                    <Col xs={12}>
                                        <strong>Type of Expenditure</strong>
                                        {
                                            expenditureTypes.map((et) =>
                                                <div key={et.id}>
                                                    <label>
                                                        <input type="radio" {...register('expendituretypeid')} value={et.id} />
                                                        {et.name}
                                                    </label>
                                                </div>)
                                        }
                                        <FormInputValidationMessage error={errors?.expendituretypeid} />
                                    </Col>
                                </Row>
                            </Col>
                            <Col xs={12} md={6}>
                                <div className={styles.formBox}>
                                    <strong className="d-flex justify-content-center">Vendor Information</strong>
                                    <Row>
                                        <Col xs={12}>
                                            <label htmlFor="vendorName">Vendor Name</label>
                                            <input id="vendorName" type="text" {...register('vendorname')} style={{ width: '100%' }} />
                                            <FormInputValidationMessage error={errors?.vendorname} />
                                        </Col>
                                        <Col xs={12} md={8}>
                                            <label htmlFor="vendorAddress">Vendor Address</label>
                                            <input id="vendorAddress" type="text" {...register('vendoraddress')} style={{ width: '100%' }} />
                                        </Col>
                                        <Col xs={12} md={4}>
                                            <label htmlFor="vendorPhone">Phone</label>
                                            <input id="vendorPhone" type="tel" {...register('vendorphone')} style={{ width: '100%', height: '30px' }} />
                                        </Col>
                                        <Col xs={12} md={4}>
                                            <label htmlFor="vendorCity">City</label>
                                            <input id="vendorCity" type="text" {...register('vendorcity')} style={{ width: '100%', height: '30px' }} />
                                        </Col>
                                        <Col xs={12} md={4}>
                                            <label htmlFor="vendorState">State</label>
                                            <Controller
                                                name="vendorstate"
                                                control={control}
                                                render={({field}) => (
                                                    <select {...field} style={{width: '100%',height: '30px'}} id="vendorState" onChange={(e) => {
                                                                    field.onChange(parseInt(e.target.value,10))
                                                            }}>
                                                            <option value={-1}>--Select State--</option>
                                                            {
                                                                states.map((state) => (
                                                                    <option key={state.id} value={state.id}>{state.name}</option>
                                                                ))
                                                            }
                                                    </select>
                                                )}
                                            />
                                        </Col>
                                        <Col xs={12} md={4}>
                                            <label htmlFor="vendorZip">Zip</label>
                                            <input type="text" id="vendorZip" {...register('vendorzip')} style={{ width: '100%', height: '30px' }} />
                                        </Col>
                                        <Col xs={12}>
                                            <label htmlFor="vendorNote">Vendor Note</label>
                                            <textarea id="vendorNote" {...register('vendornote')} rows={4} style={{ width: '100%' }} />
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                            <Col xs={12}>
                                <label htmlFor="comments">Comments</label>
                                <textarea id="comments" {...register('comments')} style={{ width: '100%' }} rows={5} />
                            </Col>
                        </Row>
                        <Row className="mt-4 mb-2">
                            <Col xs={12}>
                                <ReceiptsPanel fields={receiptItems} setField={setReceiptItems} lineItemCategories={lineItemCategories} readOnly={readOnly}/>
                                {
                                    mismatchLineItemsAndAmount
                                    ?
                                        <div className="d-flex justify-content-end">
                                            <small style={{color: 'red'}}>Procard amount and line item totals do not match.</small>
                                        </div>
                                    :
                                        null

                                }
                            </Col>
                            <Col xs={12}>
                                <FileUpload
                                    title="Supporting Documents"
                                    previousFiles={prevFiles} 
                                    newFiles={newFiles} 
                                    setNewFiles={setNewFiles} 
                                    setPrevFiles={setPrevFiles}
                                    FileDownloadData={{ProcardID: procardId}}
                                    prevFileDownloadEndpointKey="ExpenditureWorksheet_Procard_FileDownload" 
                                    readOnly={readOnly}
                                />
                            </Col>
                        </Row>
                    </div>
                    <div className="d-flex justify-content-between align-items-center mt-2">
                        <Button type="button" variant={readOnly ? "secondary" : "danger"} onClick={returnFunction} disabled={isSubmitting}>{readOnly ? "Return" : "Cancel"}</Button>
                        {
                            !readOnly
                            ?
                                <Button type="submit" variant={procardId !== null ? 'primary' : 'success'} disabled={isSubmitting || (!isDirty && !newFiles.length > 0 && !existingFilesChanged && !existingLineItemsChanged)}>
                                    {
                                        !isSubmitting
                                        ?
                                            procardId
                                            ?
                                                <>
                                                    <FontAwesomeIcon icon={faSave} size="xl" className="me-1" />
                                                    Save Changes
                                                </>
                                            :
                                                <>
                                                    <FontAwesomeIcon icon={faPlus} size="xl" className="me-1" />
                                                    Add Procard
                                                </>
                                        :
                                            <Spinner animation='border' size='sm' />
                                    }
                                </Button>
                            :
                                null
                        }
                    </div>
                </div>
            </div>
        </form>
    )
}

export default ExpenditureProCardAddEdit;
